import { useDispatch, useSelector } from "react-redux";
import EditIcon from "../../assets/images/EditIcon";
import { StaffListConstants, UserStatus } from "../../constants/constants";
import { AppDispatch, RootState } from "../../store/store";
import { UserProfile } from "./UserProfile";
import Button from "./cta/Button";
import { Cancel, editProfile, sendSmsButton } from "./styles/CommonStyles";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import SendSMSIcon from "../../assets/images/SendSMSIcon";
import { getUserValidationStatus } from "./UserValidation";
import { resendConsentLinkAsync } from "../../store/thunks/userThunk";
import { json } from "stream/consumers";

export const UserProfileDetail = ({
  isEditMode,
  handleEditButton,
  handleCancelButton,
  handleSaveButton,
  activeTab,
  editButtonName,
  handleAddMoreRolesButton,
  jsonObjData,
  isAndroid = false,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();

  let isEditButtonVisible =
    (jsonObjData?.id && jsonObjData?.id.toString()) ===
      readFromLocalStorage("userId") ||
    jsonObjData?.status === UserStatus.INACTIVE
      ? false
      : true;

  return (
    <div
      className={`flex bg-white p-4  ${
        !isAndroid ? "px-5 p-5 " : "pb-4 border rounded-lg mx-4"
      } flex-col md:flex-row md:items-center md:justify-between gap-4 `}
    >
      {/* User Profile section */}
      <div className="w-full md:w-auto">
        <UserProfile
          getUserValidationStatus={getUserValidationStatus}
          jsonObjData={jsonObjData}
          isAndroid={isAndroid}
        />
      </div>

      {/* Button Section */}
      <div
        className={`w-full   ${
          isAndroid
            ? "flex justify-between items-center gap-2 "
            : "flex justify-end items-center"
        }`}
      >
        {jsonObjData?.consentStatus === false && isEditButtonVisible && (
          <div className="pr-4  w-full md:w-auto">
            <Button
              handleClick={() =>
                dispatch(
                  resendConsentLinkAsync(jsonObjData?.userId?.toString() ?? "")
                )
              }
              buttonText={StaffListConstants.sendConsentSMSLink}
              className={`${sendSmsButton} py-3 px-4`}
              prefixIcon={<SendSMSIcon />}
            />
          </div>
        )}

        {activeTab !== 2 && activeTab !== 1 && isEditButtonVisible && (
          <div className=" w-full md:w-auto">
            {!isEditMode ? (
              <Button
                handleClick={handleEditButton}
                buttonText={editButtonName}
                className={editProfile}
                prefixIcon={<EditIcon />}
              />
            ) : (
              <div className="flex items-center justify-end gap-2">
                <Button
                  handleClick={handleCancelButton}
                  buttonText={StaffListConstants.Cancel}
                  className={Cancel}
                />
                <Button
                  handleClick={handleSaveButton}
                  buttonText={StaffListConstants.Save}
                  className={editProfile}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
